import React from "react";
import CheckoutField from "./CheckoutField";
import CheckoutSection from "./CheckoutSection";

const ShippingAddressForm = ({ form, onUpdate }) => (
  <>
    <CheckoutSection title="01 / Contact">
      <CheckoutField label="Full Name" required value={form.full_name} onChange={(value) => onUpdate("full_name", value)} testid="full-name" />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <CheckoutField label="Email" type="email" required value={form.email} onChange={(value) => onUpdate("email", value)} testid="email" />
        <CheckoutField label="Phone" type="tel" required value={form.phone} onChange={(value) => onUpdate("phone", value)} testid="phone" />
      </div>
    </CheckoutSection>

    <CheckoutSection title="02 / Shipping Address">
      <CheckoutField label="Address Line 1" required value={form.address_line1} onChange={(value) => onUpdate("address_line1", value)} testid="addr1" />
      <CheckoutField label="Address Line 2 (optional)" value={form.address_line2} onChange={(value) => onUpdate("address_line2", value)} testid="addr2" />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        <CheckoutField label="City" required value={form.city} onChange={(value) => onUpdate("city", value)} testid="city" />
        <CheckoutField label="State" required value={form.state} onChange={(value) => onUpdate("state", value)} testid="state" />
        <CheckoutField label="Pincode" required value={form.pincode} onChange={(value) => onUpdate("pincode", value)} testid="pincode" />
      </div>
      <CheckoutField label="Country" required value={form.country} onChange={(value) => onUpdate("country", value)} testid="country" />
    </CheckoutSection>
  </>
);

export default ShippingAddressForm;
